import { render, staticRenderFns } from "./modalEmployeeBuilding.vue?vue&type=template&id=2f9028c0&"
import script from "./modalEmployeeBuilding.vue?vue&type=script&lang=js&"
export * from "./modalEmployeeBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports